// Simple default avatar as data URL (gray circle with white person icon)
export const DEFAULT_AVATAR = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgZmlsbD0iIzk5OSIvPjxjaXJjbGUgY3g9IjIwIiBjeT0iMTUiIHI9IjYiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNIDggMzIgUSA4IDI2IDIwIDI2IFEgMzIgMjYgMzIgMzIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L3N2Zz4=';

// Generate a default avatar with the first letter of the username
export const getDefaultAvatarWithInitial = (username) => {
  if (!username) return DEFAULT_AVATAR;
  const initial = username.charAt(0).toUpperCase();
  // Create SVG with gray background, white person icon, and letter overlay
  const svg = `<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#999"/>
    <circle cx="20" cy="15" r="6" fill="#fff" opacity="0.3"/>
    <path d="M 8 32 Q 8 26 20 26 Q 32 26 32 32" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" opacity="0.3"/>
    <text x="20" y="20" text-anchor="middle" dominant-baseline="central" font-size="36" font-weight="bold" fill="#000" font-family="Arial, sans-serif">${initial}</text>
  </svg>`;
  return 'data:image/svg+xml;base64,' + btoa(svg);
};

